import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {zip} from "rxjs";
import {
  GetInformacionLicenciaService
} from "../../../shared/modules/get-informacion-licencia/get-informacion-licencia.service";
import {
  ObtenerTokenClienteBraintreeService
} from "../../../../domain/administrador/modules/informacion-facturacion/obtener-token-cliente-braintree.service";
import {environment} from "../../../../../environments/environment";
import * as dropin from 'braintree-web-drop-in';
import {NgxUiLoaderService} from "ngx-ui-loader";
import {
  ActualizarBraintreeTokenService
} from "../../../../domain/administrador/modules/informacion-licencia/actualizar-braintree-token.service";
import {ToastrService} from "ngx-toastr";
import {InformacionLicencia} from "../../../shared/modules/get-informacion-licencia/informacion-licencia";
import {
  ObtenerInformacionFacturacionEmpresaService
} from "../../../shared/services/obtener-informacion-facturacion-empresa/obtener-informacion-facturacion-empresa.service";
import {InformacionFacturacion} from "../../../super-administrador/interfaces/informacion-facturacion";

@Component({
  selector: 'app-metodo-de-pago',
  templateUrl: './metodo-de-pago.component.html',
  styleUrls: ['./metodo-de-pago.component.scss']
})
export class MetodoDePagoComponent implements OnInit {
  public informacionLicencia: InformacionLicencia;
  public informacionFacturacion: InformacionFacturacion;
  @Input('mostrarBotonActualizar') public mostrarBotonActualizar: boolean = true;
  @ViewChild('submitButton') public submitButton: ElementRef<HTMLElement>;
  @Output() licenciaActualizada = new EventEmitter<number>();

  constructor(
    private getInformacionLicenciaService: GetInformacionLicenciaService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastrService: ToastrService,
    private actualizarBraintreeTokenService: ActualizarBraintreeTokenService,
    private obtenerTokenClienteBraintreeService: ObtenerTokenClienteBraintreeService,
    private obtenerInformacionFacturacionEmpresaService: ObtenerInformacionFacturacionEmpresaService) {
  }

  ngOnInit(): void {
    this.obtenerInformacionMetodoDePago();
  }

  public createBraintreeUI(token?: string): void {
    const submitButton = document.querySelector('#submit-button');
    const braintreeData = {
      authorization: token ?? environment.braintreeToken,
      vaultManager: !!token,
      threeDSecure: true,
      selector: '#dropin-container',
      locale: 'es_ES',
    };

    const _this = this;

    const dropinContainer = document.querySelector('#dropin-container');

    if (dropinContainer?.childNodes.length === 0) {
      dropin.create(braintreeData, function (err, dropinInstance) {
        if (err) {
          console.error(err);
          return;
        }
        submitButton.addEventListener('click', function () {
          _this.ngxUiLoaderService.start();
          dropinInstance.requestPaymentMethod({
            threeDSecure: {
              amount: _this.calculatePaymentAmount(),
              billingAddress: {
                givenName: _this.informacionFacturacion?.nombre || '',
                surname: _this.informacionFacturacion?.apellidos || '',
                streetAddress: _this.informacionFacturacion?.direccion || '',
                locality: _this.informacionFacturacion?.ciudad || '',
                postalCode: _this.informacionFacturacion?.codigo_postal || '',
                countryCodeAlpha2: _this.getCountryCode(_this.informacionFacturacion?.pais)
              }
            }
          },function (err, payload) {

            if (err) {
              _this.ngxUiLoaderService.stop();
              return;
            } else {
              _this.actualizaLicencia(payload);
            }
          });
        });
      });
    }
  }

  public obtenerInformacionMetodoDePago(): void {

    zip(
      this.getInformacionLicenciaService.__invoke(),
      this.obtenerTokenClienteBraintreeService.__invoke(),
      this.obtenerInformacionFacturacionEmpresaService.__invoke()
    ).subscribe({
      next: ([informacionLicencia, token, informacionFacturacion]) => {
        this.informacionLicencia = informacionLicencia;
        this.informacionFacturacion = informacionFacturacion;

        if ((token.token.length > 0) && informacionLicencia.tipo_licencia !== 2) {
          this.createBraintreeUI(token.token);
        }
      }, error: (errorResponse) => {
        this.toastrService.error('Error al obtener la información de facturación', 'Error');
      }
    });
  }

  public enviarPago() {
    let el: HTMLElement = this.submitButton.nativeElement;
    el.click();
  }

  private actualizaLicencia(payload: any): void {
    zip(
      this.actualizarBraintreeTokenService.__invoke(this.informacionLicencia.id),
    ).subscribe({
      next: () => {
        this.ngxUiLoaderService.stop();
        this.toastrService.success('Se han guardado los cambios con éxito', 'Información de facturacion actualizada');
        this.licenciaActualizada.emit(1);
      }, error: (errorResponse) => {
        this.ngxUiLoaderService.stop();
        this.toastrService.error('Error al actualizar la información de facturación', 'Error');
      }
    });
  }

  private getCountryCode(countryName: string | undefined): string {
    if (!countryName) return 'ES';
    
    const countryMapping: { [key: string]: string } = {
      'España': 'ES',
      'Spain': 'ES',
      'Francia': 'FR',
      'France': 'FR',
      'Alemania': 'DE',
      'Germany': 'DE',
      'Italia': 'IT',
      'Italy': 'IT',
      'Portugal': 'PT',
      'Reino Unido': 'GB',
      'United Kingdom': 'GB',
      'Estados Unidos': 'US',
      'United States': 'US'
    };

    return countryMapping[countryName] || 'ES';
  }

  private calculatePaymentAmount(): string {
    if (!this.informacionLicencia || !this.informacionLicencia.numero_usuarios_asignados) {
      return '0.00';
    }
    
    const pricePerUserWithVAT = 2.42;
    const months = 12;
    const amount = this.informacionLicencia.numero_usuarios_asignados * pricePerUserWithVAT * months;
    
    return amount.toFixed(2);
  }
}
